var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"renzh"},[_c('img',{attrs:{"src":require("../../assets/imgs/home/index-bg.png"),"alt":""}}),_c('div',{staticClass:"content flexc0c"},[_c('div',{staticClass:"title"},[_vm._v("欢迎来到中资云企业综合服务平台")]),_c('div',{staticClass:"sub-title"},[_vm._v("·矿产品行业服务综合解决方案·")])])])
}]

export { render, staticRenderFns }